import { render, staticRenderFns } from "./printCWPurReturn.vue?vue&type=template&id=243f1405&scoped=true&"
import script from "./printCWPurReturn.vue?vue&type=script&lang=js&"
export * from "./printCWPurReturn.vue?vue&type=script&lang=js&"
import style0 from "./printCWPurReturn.vue?vue&type=style&index=0&id=243f1405&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f1405",
  null
  
)

component.options.__file = "printCWPurReturn.vue"
export default component.exports